<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="专家信息入库" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }">
                            <FGCollapsiblePanel title="专家信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <a-form-item label="入库单编号" :wrapper-col="{ span: 12 }">
                                                <a-input ref="rkdbh" v-model="editData.rkdbh" disabled />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="姓名" :wrapper-col="{ span: 12 }" required>
                                            <a-input ref="xm" v-model="editData.xm" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="4">
                                        <div class="image-container">
                                            <UploadImage :attachCfg="attachImageCfg_Edit" item-name="照片" />
                                        </div>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="性别" :wrapper-col="{ span: 12 }" required>
                                            <FGDictSelectCN ref="xb" dictNo="RY100101" v-model="editData.xb" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="身份证号" :wrapper-col="{ span: 12 }" required>
                                            <a-input ref="sfzh" oninput="value=value.replace(/[^0-9Xx]/g,'')" v-model="editData.sfzh" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="微信号" :wrapper-col="{ span: 12 }" required>
                                            <a-input ref="wxh" v-model="editData.wxh" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="本人手机" :wrapper-col="{ span: 12 }" required>
                                            <a-input ref="brsj" oninput="value=value.replace(/\D/g,'')" v-model="editData.brsj" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="单位电话" :wrapper-col="{ span: 12 }" required>
                                            <a-input ref="dwdh" v-model="editData.dwdh" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="推荐单位联系人" :wrapper-col="{ span: 12 }" required>
                                            <a-input ref="tjdwlxr" v-model="editData.tjdwlxr" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="推荐人手机号" :wrapper-col="{ span: 12 }" required>
                                            <a-input ref="tjrsjh" v-model="editData.tjrsjh" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="所属行业" :wrapper-col="{ span: 12 }" required>
                                            <a-input-search ref="sshy" readOnly @search="isShow_sshy = true" v-model="editData.sshy" />
                                            <FGDataSelect
                                                :isShow.sync="isShow_sshy"
                                                selectNo="JC1002"
                                                :multiSelect="true"
                                                @saveselect="saveEvent_sshy(arguments)"
                                            ></FGDataSelect>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="专家类型" :wrapper-col="{ span: 12 }" required>
                                            <FGDictSelectCN
                                                ref="zjlx"
                                                dictNo="XZJ200101"
                                                v-model="editData.zjlx"
                                                mode="multiple"
                                                @change="changeItemCJYYData"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <a-form-item label="行政职务" :wrapper-col="{ span: 12 }">
                                                <a-input ref="xzzw" v-model="editData.xzzw" />
                                            </a-form-item>
                                            <template slot="title">
                                                指申请人在社保缴纳单位的行政职务,如没有则填“无”
                                            </template>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人擅长的专业,例如:煤炭行业中的采煤专业、洗选煤专业,如有多个专业可同时填写。
                                            </template>
                                            <a-form-item label="专业" :wrapper-col="{ span: 12 }">
                                                <a-input ref="zy" v-model="editData.zy" />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人社保缴纳单位全称,如退休请填退休前所在单位。
                                            </template>
                                            <a-form-item label="工作单位" :wrapper-col="{ span: 12 }" required>
                                                <a-input-search ref="gzdw" readOnly @search="isShow_gzdw = true" v-model="editData.gzdw" />
                                                <FGDataSelect
                                                    :isShow.sync="isShow_gzdw"
                                                    selectNo="DW1001"
                                                    @saveselect="saveEvent_gzdw(arguments, editData)"
                                                ></FGDataSelect>
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人通信地址或经邮政部门批准使用的邮政信箱号
                                            </template>
                                            <a-form-item label="通信地址" :wrapper-col="{ span: 12 }">
                                                <a-input ref="txdz" v-model="editData.txdz" />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人获得的专业技术职称名称。
                                            </template>
                                            <a-form-item label="专业技术职称" :wrapper-col="{ span: 12 }" required>
                                                <FGDictSelectCN ref="zyjszc" dictNo="XZJ200102" v-model="editData.zyjszc" />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人获得专业技术职称的时间。按照年月填写。
                                            </template>
                                            <a-form-item label="职称获得时间" :wrapper-col="{ span: 12 }" required>
                                                <a-month-picker ref="zchdsj" v-model="editData.zchdsj" valueFormat="YYYY-MM-01" style="width:100%" />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人从事工程咨询工作的年限。
                                            </template>
                                            <a-form-item label="从事工程咨询工作的年限">
                                                <a-input ref="csnx" v-model="editData.csnx" type="number" />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人初次获得咨询工程师(投资)职业资格的时间。按照年月填写。
                                            </template>
                                            <a-form-item label="首次获得咨询工程师（投资）时间" :wrapper-col="{ span: 12 }">
                                                <a-month-picker ref="schdzxgcssj" v-model="editData.schdzxgcssj" valueFormat="YYYY-MM-01" style="width:100%" />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人咨询工程师(投资)证书登记的专业。
                                            </template>
                                            <a-form-item label="登记专业" :wrapper-col="{ span: 12 }">
                                                <a-input ref="djzy" v-model="editData.djzy" />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人获得的其他职业或执业资格(资质)。
                                            </template>
                                            <a-form-item label="获得其他资格（资质）名称1" :wrapper-col="{ span: 12 }">
                                                <a-input ref="hdqtzgmc1" v-model="editData.hdqtzgmc1" />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-tooltip>
                                            <template slot="title">
                                                指申请人获得的其他职业或执业资格(资质)的时间。按照年月填写。
                                            </template>
                                            <a-form-item label="获得时间1" :wrapper-col="{ span: 12 }">
                                                <a-month-picker ref="hdsj1" v-model="editData.hdsj1" valueFormat="YYYY-MM-DD" style="width:100%" />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="获得其他资格（资质）名称2" :wrapper-col="{ span: 12 }">
                                            <a-input ref="hdqtzgmc2" v-model="editData.hdqtzgmc2" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="获得时间2" :wrapper-col="{ span: 12 }">
                                            <a-month-picker ref="hdsj2" v-model="editData.hdsj2" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="获得其他资格（资质）名称3" :wrapper-col="{ span: 12 }">
                                            <a-input ref="hdqtzgmc3" v-model="editData.hdqtzgmc3" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="获得时间3" :wrapper-col="{ span: 12 }">
                                            <a-month-picker ref="hdsj3" v-model="editData.hdsj3" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="18">
                                        <a-tooltip>
                                            <template slot="title">
                                                按照申报专家类型和行业要求,重点填写申请人工作经历、主要工作领域、业务范畴、专业特长、参加过的重要工作和在工作中的职责、取得的主要成绩等。
                                            </template>
                                            <a-form-item label="工作简述" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                                                <a-textarea v-model="editData.gzjs" :rows="3" placeholder="" />
                                            </a-form-item>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="用户名" :wrapper-col="{ span: 12 }" required>
                                            <a-input-search
                                                ref="yhm"
                                                v-model="editData.yhm"
                                                @search="checkUsername"
                                                @change="
                                                    () => {
                                                        usernameFlag.type = false;
                                                    }
                                                "
                                            >
                                                <a-button slot="enterButton">
                                                    用户名检测
                                                </a-button>
                                            </a-input-search>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="密码" :wrapper-col="{ span: 12 }" required>
                                            <a-input-password ref="mm" v-model="editData.mm" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="申报单位" :wrapper-col="{ span: 12 }">
                                            <a-input ref="sbdw" v-model="editData.sbdw" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="录入部门" :wrapper-col="{ span: 12 }">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="录入人" :wrapper-col="{ span: 12 }">
                                            <a-input ref="lrrxm" v-model="editData.lrrxm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="录入时间" :wrapper-col="{ span: 12 }">
                                            <a-date-picker ref="lrrq" v-model="editData.lrrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel
                                title="本人主持或主导过主要业绩（包括编制行业标准）"
                                tooltip="指根据申请的专家类型,按照中国工程咨询协会专家所列标准填写相关业绩,可以增加业绩行数。"
                            >
                                <vxe-toolbar size="mini">
                                    <template v-slot:tools>
                                        <a-button type="primary" :loading="saving || loading" @click="insertZYYJ">新增</a-button>
                                    </template>
                                </vxe-toolbar>
                                <vxe-table
                                    ref="itemZYYJTable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    show-overflow="tooltip"
                                    :data="editItemZYYJData"
                                    :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                                >
                                    <vxe-table-column type="seq" title="序号" width="60" align="center"></vxe-table-column>
                                    <vxe-table-column
                                        field="yjmc"
                                        title="业绩名称"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.yjmc" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="wcsj"
                                        title="完成时间"
                                        align="center"
                                        header-class-name="required"
                                        width="180px"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-date-picker ref="wcsj" v-model="scope.row.wcsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column title="操作" width="70" align="center">
                                        <template v-slot="scope">
                                            <span class="btn_edit" @click="removeZYYJ(scope.row)">删除</span>
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel
                                title="近五年来获得的主要奖励"
                                tooltip="指申请人获得过的省协会优秀工程咨询成果（水平）二等奖以上及中国工程咨询协会优秀工程咨询成果奖三等及工程咨询类奖项或市级以上政府部分颁发的奖励等。"
                            >
                                <vxe-toolbar size="mini">
                                    <template v-slot:tools>
                                        <a-button type="primary" :loading="saving || loading" @click="insertZYJL">新增</a-button>
                                    </template>
                                </vxe-toolbar>
                                <vxe-table
                                    ref="itemZYJLTable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    show-overflow="tooltip"
                                    :data="editItemZYJLData"
                                    :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                                >
                                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                                    <vxe-table-column
                                        field="hjxmmc"
                                        title="获奖项目名称"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.hjxmmc" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="jxmcjdj"
                                        title="奖项名称及等级"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.jxmcjdj" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="pjdw"
                                        title="评奖单位"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.pjdw" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="cyjs"
                                        title="A：负责人 B：参加者"
                                        align="center"
                                        header-class-name="required"
                                        width="180px"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="cyjs" dictNo="XZJ200103" v-model="scope.row.cyjs" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column title="操作" width="70" align="center">
                                        <template v-slot="scope">
                                            <span class="btn_edit" @click="removeZYJL(scope.row)">删除</span>
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel
                                title="参加意愿"
                                tooltip="愿意参与的工作选项(可多选):指申请人愿意参与的工作类型(填编号),可多选。例如:申报参与行业智库建设专家,在相应选项中填入Z ,同时参与学术类智库建设的,在相应选项中填入X1"
                            >
                                <vxe-table
                                    ref="itemCJYYTable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    show-overflow="tooltip"
                                    :data="editItemCJYYData"
                                    :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                                    :span-method="rowspanMethod"
                                    :checkbox-config="{ trigger: 'row', highlight: false, range: true, showHeader: false }"
                                >
                                    <vxe-table-column field="zjlx" title="专家类型" width="180px" align="center"> </vxe-table-column>
                                    <vxe-table-column field="gzxx" title="工作选项（可多选）" align="left"> </vxe-table-column>
                                    <vxe-table-column
                                        field="gxbj"
                                        title="勾选自愿参加的选项"
                                        align="center"
                                        header-class-name="required"
                                        width="200px"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot="scope">
                                            <a-checkbox :checked="scope.row.gxbj === 1" />
                                        </template>
                                        <template v-slot:edit="scope">
                                            <a-checkbox
                                                :checked="scope.row.gxbj === 1"
                                                @change="
                                                    (e) => {
                                                        scope.row.gxbj = e.target.checked ? 1 : 0;
                                                        scope.row.ygxbj = e.target.checked ? 1 : 0;
                                                    }
                                                "
                                                :disabled="!editData.zjlx.includes(scope.row.zjlx)"
                                            />
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                        </a-form>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachUploadZJ :isnew="editData.isnew" :attachCfg.sync="attachCfg" :isDelete="true" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "ZjxxrkEdit",
    props: ["showEdit", "dataId"],
    components: {},
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            isShow_gzdw: false,
            isShow_sshy: false,
            // 主要业绩明细数据
            editItemZYYJData: [],
            editItemZYYJDataLoading: false,
            // 主要奖励明细数据
            editItemZYJLData: [],
            editItemZYJLDataLoading: false,
            // 参加意愿明细数据
            editItemCJYYData: [],
            editItemCJYYDataLoading: false,
            usernameFlag: {
                type: false
            },
            checked: false
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading || this.editItemZYYJDataLoading || this.editItemZYJLDataLoading || this.editItemCJYYDataLoading;
        },
        attachCfg() {
            return {
                fktable: "XZJ_ZJRKB",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "XZJ200102"
            };
        },
        attachImageCfg_Edit() {
            return {
                fktable: "XZJ_ZJRKB",
                fkvalue: this.editData.id
            };
        }
    },
    activated() {
        this.usernameFlag.type = false;
        // 主要业绩明细数据
        this.editItemZYYJData = [];
        // 主要奖励明细数据
        this.editItemZYJLData = [];
        // 参加意愿明细数据
        this.editItemCJYYData = [];
        if (!this.editDataId) {
            this.$FG_helper.handleNewBillCode("RKDBH").then((val) => {
                // 新增，设置默认值
                this.editData = {
                    id: this.$FG_util.uuid(),
                    isnew: true,
                    bmid: this.getUserInfo.org_id,
                    yhid: this.getUserInfo.id,
                    djlxid: "ZJXXRK",
                    ryid: this.getUserInfo.personnel_id,
                    rkdbh: val,
                    lrbmmc: this.getUserInfo.org_name,
                    lrrxm: this.getUserInfo.personnel_name,
                    lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                    yhm: "",
                    mm: "jsaec@88888888",
                    djzt: "制定",
                    //根据当前用户单位信息设置默认值
                    gzdwid: this.getUserInfo.companyInfo.id,
                    gzdw: this.getUserInfo.companyInfo.dwmc,
                    sbdwid: this.getUserInfo.companyInfo.id,
                    sbdw: this.getUserInfo.companyInfo.dwmc
                    //dwlb: this.getUserInfo.companyInfo.dwlb,
                    //dwxz: this.getUserInfo.companyInfo.dwxz,
                    //hyfl: this.getUserInfo.companyInfo.hyfl
                };
            });
            this.$FG_helper.handleNewBillCode("ZJYHM1001").then((val) => {
                this.editData.yhm = val;
            });
        } else {
            // 修改，加载数据
            this.loadData();
        }
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.zjxm.focus();
        });
    },
    methods: {
        checkUsername() {
            this.$FG_http
                .post(
                    "./api/admin/user/check",
                    {
                        username: this.editData.yhm
                    },
                    { showSuccess: false }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        this.usernameFlag.type = data.data;
                        if (data.data) {
                            this.$FG_message.warn("当前用户名可用！").then(() => this.$refs.yhm.focus());
                        } else {
                            this.$FG_message.error("当前用户名已被注册！").then(() => this.$refs.yhm.focus());
                        }
                    } else {
                        this.$refs.yhm.focus();
                    }
                });
        },
        //提交form
        onSave(btnType) {
            let itemZYYJData = this.$refs.itemZYYJTable.getTableData().tableData;
            let itemZYJLData = this.$refs.itemZYJLTable.getTableData().tableData;
            let itemCJYYData = this.$refs.itemCJYYTable.getTableData().tableData;
            if (btnType === 1 || btnType === 0) {
                // 表单校验
                if (!this.editData.xm) {
                    this.$FG_message.error("P0001", "姓名").then(() => this.$refs.xm.focus());
                    return;
                }
                if (!this.editData.xb) {
                    this.$FG_message.error("P0001", "性别").then(() => this.$refs.xb.focus());
                    return;
                }
                if (!this.editData.sfzh) {
                    this.$FG_message.error("P0001", "身份证号").then(() => this.$refs.sfzh.focus());
                    return;
                }
                if (!this.editData.wxh) {
                    this.$FG_message.error("P0001", "微信号").then(() => this.$refs.wxh.focus());
                    return;
                }
                if (!this.editData.brsj) {
                    this.$FG_message.error("P0001", "本人手机").then(() => this.$refs.brsj.focus());
                    return;
                }
                if (!this.editData.dwdh) {
                    this.$FG_message.error("P0001", "单位电话").then(() => this.$refs.dwdh.focus());
                    return;
                }
                if (!this.editData.tjdwlxr) {
                    this.$FG_message.error("P0001", "推荐单位联系人").then(() => this.$refs.tjdwlxr.focus());
                    return;
                }
                if (!this.editData.tjrsjh) {
                    this.$FG_message.error("P0001", "推荐人手机号").then(() => this.$refs.tjrsjh.focus());
                    return;
                }
                if (!this.editData.sshy) {
                    this.$FG_message.error("P0001", "所属行业").then(() => this.$refs.sshy.focus());
                    return;
                }
                if (!this.editData.zjlx || this.editData.zjlx.length === 0) {
                    this.$FG_message.error("P0001", "专家类型").then(() => this.$refs.zjlx.focus());
                    return;
                }
                if (!this.editData.gzdw) {
                    this.$FG_message.error("P0001", "工作单位").then(() => this.$refs.gzdw.focus());
                    return;
                }
                if (!this.editData.zyjszc) {
                    this.$FG_message.error("P0001", "专业技术职称").then(() => this.$refs.zyjszc.focus());
                    return;
                }
                if (!this.editData.zchdsj) {
                    this.$FG_message.error("P0001", "职称获得时间").then(() => this.$refs.zchdsj.focus());
                    return;
                }
                if (this.editData.zyjszc === "副高") {
                    if (!this.editData.schdzxgcssj) {
                        this.$FG_message.error("P0001", "首次获得咨询工程师（投资）时间").then(() => this.$refs.schdzxgcssj.focus());
                        return;
                    }
                }
                if (!this.editData.yhm) {
                    this.$FG_message.error("P0001", "用户名").then(() => this.$refs.yhm.focus());
                    return;
                }
                if (!this.editData.mm) {
                    this.$FG_message.error("P0001", "密码").then(() => this.$refs.mm.focus());
                    return;
                }
                for (let i = 0; i < itemZYYJData.length; i++) {
                    if (!itemZYYJData[i].yjmc) {
                        this.$FG_message.error("P0001", "业绩名称").then(() => this.$refs.itemZYYJTable.setActiveRow(itemZYYJData[i]));
                        return;
                    }
                    if (!itemZYYJData[i].wcsj) {
                        this.$FG_message.error("P0001", "完成时间").then(() => this.$refs.itemZYYJTable.setActiveRow(itemZYYJData[i]));
                        return;
                    }
                }
                for (let i = 0; i < itemZYJLData.length; i++) {
                    if (!itemZYJLData[i].hjxmmc) {
                        this.$FG_message.error("P0001", "获奖项目名称").then(() => this.$refs.itemZYJLTable.setActiveRow(itemZYYJData[i]));
                        return;
                    }
                    if (!itemZYJLData[i].jxmcjdj) {
                        this.$FG_message.error("P0001", "奖项名称及等级").then(() => this.$refs.itemZYJLTable.setActiveRow(itemZYYJData[i]));
                        return;
                    }
                    if (!itemZYJLData[i].pjdw) {
                        this.$FG_message.error("P0001", "评奖单位").then(() => this.$refs.itemZYJLTable.setActiveRow(itemZYYJData[i]));
                        return;
                    }
                    if (!itemZYJLData[i].cyjs) {
                        this.$FG_message.error("P0001", "A：负责人 B：参加者").then(() => this.$refs.itemZYJLTable.setActiveRow(itemZYYJData[i]));
                        return;
                    }
                }
                if (!this.usernameFlag.type) {
                    this.$FG_message.error("请先完成用户名检测!").then(() => this.$refs.yhm.focus());
                    return;
                }
            }
            // 保存操作
            if (this.editData.zjlx && this.editData.zjlx.length !== 0) {
                this.editData.zjlx = this.editData.zjlx.join(",");
            }
            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/zjxx/xzjrkgl/save",
                    {
                        data: this.editData,
                        itemZYYJData,
                        itemZYJLData,
                        itemCJYYData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.dataId = this.editData.id;
                        this.editData.isnew = false;
                        this.isnew = false;
                        if (btnType === 1) {
                            if (this.editData.zjlx && this.editData.zjlx.length !== 0) {
                                this.editData.zjlx = this.editData.zjlx.split(",");
                            }
                            this.submit();
                        } else {
                            this.loadData();
                        }
                    } else {
                        this.$refs.zjxm.focus();
                    }
                });
        },
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zjxx/xzjrkgl/selectById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            if (data.data.zjlx && data.data.zjlx.length !== 0) {
                                this.editData.zjlx = data.data.zjlx.split(",");
                            }
                            this.loadItemZYYJData();
                            this.loadItemZYJLData();
                            this.loadItemCJYYData();
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载主要业绩明细表数据
        loadItemZYYJData() {
            this.editItemZYYJData = [];
            this.editItemZYYJDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zjxx/xzjrkgl/listZYYJ",
                    {
                        zjrkbid: this.editDataId,
                        sort: {
                            field: "id",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemZYYJDataLoading = false;
                    if (success) {
                        this.editItemZYYJData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载主要奖励明细表数据
        loadItemZYJLData() {
            this.editItemZYJLData = [];
            this.editItemZYJLDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zjxx/xzjrkgl/listZYJL",
                    {
                        zjrkbid: this.editDataId,
                        sort: {
                            field: "id",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemZYJLDataLoading = false;
                    if (success) {
                        this.editItemZYJLData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载参加意愿明细表数据
        loadItemCJYYData() {
            this.editItemCJYYData = [];
            this.editItemCJYYDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zjxx/xzjrkgl/listCJYY",
                    {
                        zjrkbid: this.editDataId,
                        sort: {
                            field: "id",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemCJYYDataLoading = false;
                    if (success) {
                        this.editItemCJYYData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        //判断是否包含，不包含的需要将原来勾选的去掉
        changeItemCJYYData() {
            this.editItemCJYYData = this.editItemCJYYData.map((item) => {
                if (!this.editData.zjlx.includes(item.zjlx) && item.gxbj === 1) {
                    item.gxbj = 0;
                }
                return item;
            });
        },
        //返回列表
        onBack() {
            this.editIsVisible = false;
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/zjxx/xzjrkgl/submit", {
                            funid: "XZJ2001",
                            defaulttablename: "XZJ_ZJRKB",
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                //提交之后跳转主页面
                                this.editIsVisible = false;
                            } else {
                                this.$refs.zjxm.focus();
                            }
                        });
                }
            });
        },
        saveEvent_gzdw(val, row) {
            if (val && val.length > 0) {
                this.editData.gzdwid = val[0][0].ID;
                this.editData.gzdw = val[0][0].DWMC;
            }
        },
        saveEvent_sshy(val) {
            if (val && val.length > 0) {
                this.editData.sshyid = "";
                this.editData.sshy = "";
                for (let i = 0; i < val[0].length; i++) {
                    if (i !== 0) {
                        this.editData.sshyid += "/";
                        this.editData.sshy += "/";
                    }
                    this.editData.sshyid += val[0][i].ID;
                    this.editData.sshy += val[0][i].ZYMC;
                }
            }
        },
        // 新增主要业绩明细
        insertZYYJ() {
            let xh = this.$refs.itemZYYJTable.getTableData().tableData.length + 1;
            if (xh > 5) {
                this.$FG_message.error("本人主持或主导过主要业绩，最大允许录入5行");
                return;
            }
            // 设置编辑记录
            this.$refs.itemZYYJTable
                .insertAt(
                    {
                        isnew: true,
                        id: this.$FG_util.uuid(),
                        zjrkbid: this.editData.id,
                        xh: xh
                    },
                    -1
                )
                .then(({ row }) => {
                    this.$refs.itemZYYJTable.setActiveRow(row);
                });
        },
        // 删除主要业绩明细
        removeZYYJ(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.itemZYYJTable.remove(row);
                    } else {
                        this.tableDataLoading = true;
                        this.$FG_http
                            .post("./api/main/zjxx/xzjrkgl/deleteZYYJ", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.tableDataLoading = false;
                                if (success) {
                                    this.loadItemZYYJData();
                                }
                            });
                    }
                }
            });
        },
        // 新增主要奖励明细
        insertZYJL() {
            let xh = this.$refs.itemZYJLTable.getTableData().tableData.length + 1;
            if (xh > 8) {
                this.$FG_message.error("获得奖励，最大允许录入8行");
                return;
            }
            // 设置编辑记录
            this.$refs.itemZYJLTable
                .insertAt(
                    {
                        isnew: true,
                        id: this.$FG_util.uuid(),
                        zjrkbid: this.editData.id,
                        xh: xh
                    },
                    -1
                )
                .then(({ row }) => {
                    this.$refs.itemZYJLTable.setActiveRow(row);
                });
        },
        // 删除主要奖励明细
        removeZYJL(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.itemZYJLTable.remove(row);
                    } else {
                        this.tableDataLoading = true;
                        this.$FG_http
                            .post("./api/main/zjxx/xzjrkgl/deleteZYJL", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.tableDataLoading = false;
                                if (success) {
                                    this.loadItemZYJLData();
                                }
                            });
                    }
                }
            });
        },
        rowspanMethod({ row, _rowIndex, column, visibleData }) {
            const fields = ["zjlx"];
            const cellValue = row[column.property];
            if (cellValue && fields.includes(column.property)) {
                const prevRow = visibleData[_rowIndex - 1];
                let nextRow = visibleData[_rowIndex + 1];
                if (prevRow && prevRow[column.property] === cellValue) {
                    return { rowspan: 0, colspan: 0 };
                } else {
                    let countRowspan = 1;
                    while (nextRow && nextRow[column.property] === cellValue) {
                        nextRow = visibleData[++countRowspan + _rowIndex];
                    }
                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 };
                    }
                }
            }
        },
        check1ChangeEvent(row, checked) {
            // console.log(checked);
            // console.log(row);
        }
    }
};
</script>
<style lang="scss" scoped>
.collapsible-panel-title {
    width: 100%;
    height: 20px;
    margin: 24px 0 0 0;
    display: flex;

    .collapsible-panel-title-txt {
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        color: #1e202d;
        border-left: 5px solid #33cde5;
        padding: 0 8px;
    }

    .collapsible-panel-title-content {
        font-size: 14px;
        height: 20px;
        color: #f77824fb;
        background-color: #f5ece4;
    }
}
</style>
